import React, { Component } from "react";
import { connect } from "react-redux";
import { TouchableHighlight, View, ScrollView, StyleSheet } from "react-native";
import Switch from "../../components/ToggleSwitch";
import Text from "../../components_v2/TextFont";
import { ArButton } from "../../argon-ui";
import Theme from "../../argon-ui/Theme";
import { translate } from "../../locales/translate";
import SearchableDropdown from "../SearchableDropDown";
import PropTypes from "prop-types";
import {
  ScenarioAction,
  ScenarioAreaStateAction,
} from "../../viewModels/Scenario";
import DeviceDimmer from "../DeviceDimmer";
import {
  faChevronCircleDown,
  faChevronCircleUp,
} from "../../../assets/consts/faCharCodes";
import * as AreaHelper from "../../actions/AreaHelper";
import * as DeviceTypes from "../../components/devices/_deviceTypes";
import ConditionEventLayout from "./ConditionEventLayout";
import TabBase from "../../nativeBase-ui/TabBase";

/**@augments{Component<Props,state>} */
class ActionGenerator extends Component {
  static propTypes = {
    areaId: PropTypes.number,
    areaUId: PropTypes.string,
    areaName: PropTypes.string,
    onConfirm: PropTypes.func,
    onConfirmAreaState: PropTypes.func,
    // onConfirmAreaState: (action: ScenarioAreaStateAction) => void
  };
  constructor(props) {
    super(props);
    this.state = {
      areaId: this.props.areaId,
      areaUId: this.props.areaUId,
      areaName: this.props.areaName,
      manager: "",
      action: "",
      deviceId: undefined,
      deviceUId: undefined,
      deviceName: "",
      parameterTypes: [],
      parameterNames: [],
      parameterValues: [],
      tab: "batch", // batch | single
    };
    this.managers = [];
    this.managerBatchActions = [];
    this.managerSingleActions = [];
    this.managerDevices = [];
    this.areaStates = [];
    this.tabs = ["single", "batch"];
  }

  componentDidMount() {}

  handleOnConfirm = () => {
    if (!this.props.onConfirm) {
      return;
    }

    var managerModel = {};
    var actionModel = {};

    managerModel = this.findManagerByName(this.state.manager);

    for (var j in managerModel.actions) {
      if (managerModel.actions[j].action == this.state.action) {
        actionModel = managerModel.actions[j];
        break;
      }
    }
    if (managerModel.manager == "AreaStateManager") {
      // ===  find area state selected by deviceId or deviceUId ===
      const findArea = this.props.areaReducer?.areas.find(
        (area) =>
          area?.areaId == this.state.areaId ||
          area?.areaUId == this.state.areaUId
      );
      const findState = findArea?.userDefinedStates?.find(
        (state) =>
          state.id == this.state.deviceId || state.uId == this.state.deviceUId
      );
      var areaStateAction = new ScenarioAreaStateAction();
      // Object.assign(areaStateAction, action);
      areaStateAction.areaId = findArea?.areaId;
      areaStateAction.areaUId = findArea?.areaUId;
      areaStateAction.areaName = findArea?.areaName;

      areaStateAction.stateId = findState?.id || 0;
      areaStateAction.stateUId = findState?.uId || "";
      areaStateAction.stateName = findState?.name;

      areaStateAction.action = this.state.action;
      areaStateAction.manager = this.state.manager;

      this.props.onConfirmAreaState(areaStateAction);
    } else {
      var result = new ScenarioAction();
      result.action = this.state.action;
      result.areaId = this.state.areaId;
      result.areaUId = this.state.areaUId;
      result.areaName = this.state.areaName;
      result.manager = this.state.manager;
      if (
        result.manager == "ElevatorManager" &&
        result.action == "SendToFloor"
      ) {
        result.parameterTypes = ["elevatorFloor"];
      } else {
        result.parameterTypes = actionModel.parameterTypes;
      }
      result.parameterNames = actionModel.parameterNames;
      result.parameters = this.state.parameterValues;
      result.deviceName = this.state.deviceName;
      // ===  find devices selected by deviceId or deviceUId ===
      const _devices = this.props.deviceReducer.list.find(
        (device) =>
          device.deviceId == this.state.deviceId ||
          device.deviceUId == this.state.deviceId
      );
      result.deviceId = _devices?.deviceId || 0;
      result.deviceUId = _devices?.deviceUId || "";
      this.props.onConfirm(result);
    }
  };

  handleTabChange = (tab) => {
    this.setState(
      {
        tab,
        action: "",
        deviceId: undefined,
        deviceUId: undefined,
        parameterTypes: [],
        parameterNames: [],
        parameterValues: [],
      },
      () => {}
    );
  };

  onManagerSelect = (manager) => {
    var managerModel = this.findManagerByName(manager);

    for (var i in managerModel.actions) {
      let { action, isBatchAction } = managerModel.actions[i];
      var item = {
        id: action,
        name: translate(`scenario.actionsList.${action}`),
      };
      if (isBatchAction) {
        this.managerBatchActions.push(item);
      } else {
        this.managerSingleActions.push(item);
      }
    }

    // reset devices dropdown
    this.managerDevices = [];
    this.areaStates = [];
    var area = AreaHelper.findAreaById(
      this.props.areaReducer.areas,
      this.state.areaId || this.state.areaUId
    );
    let { tab } = this.state;
    let action = "";
    if (manager == "AreaStateManager") {
      tab = "areaState";
      action = "Activate";
      this.areaStates = area.userDefinedStates.map((s) => {
        return {
          id: s.id || s.uId,
          name: s.name,
        };
      });
    } else if (area && Array.isArray(area.devices) && area.devices.length) {
      if (
        this.managerBatchActions.length == 0 &&
        this.managerSingleActions.length > 0
      ) {
        tab = "single";
      } else {
        tab = "batch";
      }

      let allDevices = this.props.deviceReducer.list;
      const _areaDevices = area.devices ? area.devices : area.uDevices;
      for (var i in _areaDevices) {
        for (var j in allDevices) {
          const _devices = _areaDevices[i];
          if (
            (_devices == allDevices[j].deviceId ||
              _devices == allDevices[j].deviceUId) &&
            !allDevices[j].statusRelayId && // has no status relay (for air-conditioners only)
            managerModel.deviceType
              .split(",")
              .indexOf(allDevices[j].deviceType) >= 0
          ) {
            this.managerDevices.push({
              id: allDevices[j].deviceId || allDevices[j].deviceUId,
              name: allDevices[j].deviceName,
            });
          }
        }
      }
    } else {
      tab = "batch";
    }

    // set manager name and clear action with its parameters.
    this.setState({
      tab,
      manager,
      action,
      parameterTypes: [],
      parameterNames: [],
      parameterValues: [],
    });
  };

  onManagerClear = () => {
    this.onActionClear();
    this.managerBatchActions = [];
    this.managerSingleActions = [];
    this.managerDevices = [];
    this.areaStates = [];
    this.setState({
      tab: "batch",
      manager: "",
      action: "",
      parameterTypes: [],
      parameterNames: [],
      parameterValues: [],
    });
  };

  onActionSelect = (action) => {
    var managerModel = this.findManagerByName(this.state.manager);
    var _paramTypes = [],
      _paramNames = [],
      _paramValues = [];
    if (
      managerModel &&
      managerModel.actions &&
      managerModel.actions.length > 0
    ) {
      for (var i in managerModel.actions) {
        if (managerModel.actions[i].action == action) {
          var actionModel = managerModel.actions[i];
          if (
            managerModel.manager == "ElevatorManager" &&
            actionModel.action == "SendToFloor"
          ) {
            _paramTypes.push("elevatorFloor");
            _paramNames.push("floorId");
            _paramValues.push(0);
          } else if (
            actionModel.parameterTypes &&
            actionModel.parameterTypes.length
          ) {
            for (var j in actionModel.parameterTypes) {
              var pt = actionModel.parameterTypes[j].toLowerCase();
              var pn = actionModel.parameterNames[j];
              _paramTypes.push(pt);
              _paramNames.push(pn);
              switch (pt) {
                case "bool":
                case "boolean":
                  _paramValues.push("False"); //default for boolean (like toggles,...)
                  break;
                case "int":
                case "int32":
                case "short":
                  _paramValues.push(0); //default for numbers
                  break;
                case "byte":
                  _paramValues.push(50); //default for sliders (like dimmer lights,...) 50 in bytes equals 50%
                  break;
                case "armmodel":
                  _paramValues.push({
                    shouldCloseCurtains: true,
                    shouldTurnOffLights: true,
                    shouldTurnOffAirConditioners: true,
                    shouldRunScenarios: true,
                    shouldTurnOnSirens: true,
                    shouldNotifyBreach: true,
                    shouldSmsBreach: true,
                  });
                  break;
                case "disarmmodel":
                  _paramValues.push({
                    shouldUnlockAfterDisArm: true,
                  });
                  break;
                default: //default for unknown
                  _paramValues.push("");
                  break;
              }
            }
            break;
          }
        }
      }
    }

    this.setState({
      action,
      parameterTypes: _paramTypes,
      parameterNames: _paramNames,
      parameterValues: _paramValues,
    });
  };

  onActionClear = () => {
    this.setState({
      action: "",
      parameterTypes: [],
      parameterNames: [],
      parameterValues: [],
    });
  };

  findManagerByName = (managerName) => {
    let { actionManagers } = this.props.areaReducer;
    for (var i in actionManagers) {
      if (actionManagers[i].manager == managerName) {
        return actionManagers[i];
      }
    }
  };

  getElevatorFloorSelector(
    elementKey = 0,
    selectedFloorId = 0,
    onSelect = () => {}
  ) {
    var elevator = this.props.deviceReducer.list.filter(
      (d) =>
        (d.deviceId == this.state.deviceId ||
          d.deviceUId == this.state.deviceUId) &&
        d.deviceType == DeviceTypes.ELEVATOR
    )[0];
    var items = [];
    if (elevator && Array.isArray(elevator.elevatorFloors)) {
      items = elevator.elevatorFloors.map((ef) => {
        return { id: ef.id, name: ef.label };
      });
    }
    return (
      <SearchableDropdown
        key={elementKey}
        label={translate("elevator.floor")}
        clearable={false}
        selectedValue={selectedFloorId}
        items={items}
        onSelect={(selectedFloorId) => {
          typeof onSelect === "function" && onSelect(selectedFloorId);
        }}
      />
    );
  }

  renderToggle(elementKey, text, value, callBack) {
    return (
      <TouchableHighlight
        underlayColor={"#FFF"}
        onPress={() => {
          typeof callBack === "function" && callBack(!value);
        }}
        key={elementKey}
        style={{
          flexDirection: "row",
          padding: 3,
          marginVertical: 3,
          borderRadius: 3,
          backgroundColor: Theme.COLORS.BORDER_COLOR,
        }}
      >
        <View style={{ flexDirection: "row", flex: 1 }}>
          <Text style={{ flex: 1 }}>{text}</Text>
          <Switch
            isOn={value}
            onColor={Theme.COLORS.ACTIVE}
            offColor={Theme.COLORS.MUTED}
            size="small"
            onToggle={(v) => {
              typeof callBack === "function" && callBack(v);
            }}
            animationSpeed={0}
          />
        </View>
      </TouchableHighlight>
    );
  }

  render() {
    this.managers = this.props.areaReducer.actionManagers.map((m) => {
      return { id: m.manager, name: translate(`scenario.${m.manager}`) };
    });
    return (
      <View style={{ flex: 1 }}>
        <ConditionEventLayout
          subTitle={
            translate("scenario.executingActionFor").replace("...", " ") +
            `"${this.props.areaName}"`
          }
        >
          <SearchableDropdown
            label={translate("scenario.actionCategory")}
            clearable={true}
            items={this.managers}
            onSelect={this.onManagerSelect}
            onClear={this.onManagerClear}
          />
          {/* tabs */}
          {this.state.tab != "areaState" && (
            <TabBase
              containerStyle={{ marginVertical: 10 }}
              tab={this.state.tab}
              tabs={this.tabs}
              handleChange={(tab) => this.handleTabChange(tab)}
            >
              {/* batch form */}
              {this.state.tab == "batch" && (
                <View>
                  <SearchableDropdown
                    clearable={true}
                    label={translate("scenario.actions")}
                    noItemText={translate("scenario.pickCategoryFirst")}
                    items={this.managerBatchActions}
                    onSelect={this.onActionSelect}
                    onClear={this.onActionClear}
                  />
                </View>
              )}
              {/* single form */}
              {this.state.tab == "single" && (
                <View>
                  <SearchableDropdown
                    clearable={true}
                    label={translate("device.devices")}
                    noItemText={
                      !this.state.manager
                        ? translate("scenario.pickCategoryFirst")
                        : undefined
                    }
                    items={this.managerDevices}
                    onSelect={(deviceId, deviceName) => {
                      this.setState({ deviceId, deviceName });
                    }}
                    onClear={() =>
                      this.setState({
                        deviceId: undefined,
                        deviceUId: undefined,
                        deviceUId: undefined,
                      })
                    }
                  />
                  <SearchableDropdown
                    clearable={true}
                    label={translate("scenario.actions")}
                    items={
                      this.state.deviceId
                        ? this.managerSingleActions
                        : undefined
                    }
                    noItemText={
                      !this.state.manager
                        ? translate("scenario.pickCategoryFirst")
                        : !this.state.deviceId
                        ? translate("scenario.pickDeviceFirst")
                        : "---"
                    }
                    onSelect={this.onActionSelect}
                    onClear={this.onActionClear}
                  />
                </View>
              )}
            </TabBase>
          )}
          {/* area states form */}
          {this.state.tab == "areaState" && (
            <View style={styles.tabContent}>
              <SearchableDropdown
                clearable={true}
                label={translate("scenario.userDefinedState")}
                noItemText={
                  !this.state.manager
                    ? translate("scenario.pickCategoryFirst")
                    : undefined
                }
                items={this.areaStates}
                onSelect={(deviceId, deviceName) =>
                  this.setState({ deviceId, deviceName })
                }
                onClear={() =>
                  this.setState({ deviceId: undefined, deviceUId: undefined })
                }
              />
              {this.managerSingleActions.length !== 0 && (
                <SearchableDropdown
                  selectedValue="Activate"
                  clearable={true}
                  label={translate("scenario.actions")}
                  noItemText={
                    !this.managerSingleActions
                      ? translate("scenario.pickCategoryFirst")
                      : undefined
                  }
                  items={this.managerSingleActions}
                  onSelect={(action, name) => {
                    this.setState({ action });
                  }}
                  onClear={() => this.setState({ action: "" })}
                />
              )}
              {/* <SearchableDropdown
              clearable={true}
              label={translate("scenario.actions")}
              items={
                this.state.deviceId ? this.managerSingleActions : undefined
              }
              noItemText={
                !this.state.manager
                  ? translate("scenario.pickCategoryFirst")
                  : !this.state.deviceId
                  ? translate("scenario.pickDeviceFirst")
                  : "---"
              }
              onSelect={this.onActionSelect}
              onClear={this.onActionClear}
            /> */}
            </View>
          )}
          {/* parameter inputs */}
          <ScrollView>
            {this.state.parameterTypes &&
              this.state.parameterTypes.length > 0 &&
              this.state.parameterTypes.map((pt, i) => {
                var pn = this.state.parameterNames[i];
                if (pt == "bool" || pt == "boolean") {
                  return this.renderToggle(
                    i,
                    translate(`scenario.${this.state.parameterNames[i]}`),
                    this.state.parameterValues[i],
                    (v) => {
                      var pv = this.state.parameterValues;
                      pv[i] = v;
                      this.setState({ parameterValues: pv });
                    }
                  );
                } else if (pt == "byte")
                  return (
                    <DeviceDimmer
                      key={i}
                      style={{ paddingHorizontal: 10 }}
                      startIcon={faChevronCircleDown}
                      endIcon={faChevronCircleUp}
                      currentValue={this.state.parameterValues[i] || 0}
                      hasToggle={false}
                      onValueChange={(v) => {
                        var _ps = [...this.state.parameterValues];
                        _ps[i] = v;
                        this.setState({ parameterValues: _ps });
                      }}
                    />
                  );
                else if (pt == "int" || pt == "int32" || pt == "short")
                  return <Text key={i}>num-pad</Text>;
                else if (pt == "elevatorFloor") {
                  return this.getElevatorFloorSelector(
                    i,
                    this.state.parameterValues[i] || 0,
                    (selectedFloorId) => {
                      var _ps = [...this.state.parameterValues];
                      _ps[i] = selectedFloorId;
                      this.setState({ parameterValues: _ps });
                    }
                  );
                } else if (pt == "armmodel") {
                  return (
                    <View key={i}>
                      {/* curtains */}
                      {this.renderToggle(
                        undefined,
                        translate("area.shouldCloseCurtains"),
                        this.state.parameterValues[i].shouldCloseCurtains ||
                          false,
                        (v) => {
                          var _ps = [...this.state.parameterValues];
                          if (!_ps[i]) _ps[i] = {};

                          _ps[i].shouldCloseCurtains = v;
                          this.setState({ parameterValues: _ps });
                        }
                      )}
                      {/* lights */}
                      {this.renderToggle(
                        undefined,
                        translate("area.shouldTurnOffLights"),
                        this.state.parameterValues[i].shouldTurnOffLights ||
                          false,
                        (v) => {
                          var _ps = [...this.state.parameterValues];
                          if (!_ps[i]) _ps[i] = {};

                          _ps[i].shouldTurnOffLights = v;
                          this.setState({ parameterValues: _ps });
                        }
                      )}
                      {/* airConditioners */}
                      {this.renderToggle(
                        undefined,
                        translate("area.shouldTurnOffAirConditioners"),
                        this.state.parameterValues[i]
                          .shouldTurnOffAirConditioners || false,
                        (v) => {
                          var _ps = [...this.state.parameterValues];
                          if (!_ps[i]) _ps[i] = {};

                          _ps[i].shouldTurnOffAirConditioners = v;
                          this.setState({ parameterValues: _ps });
                        }
                      )}
                      {/* scenarios */}
                      {this.renderToggle(
                        undefined,
                        translate("area.shouldRunScenarios"),
                        this.state.parameterValues[i].shouldRunScenarios ||
                          false,
                        (v) => {
                          var _ps = [...this.state.parameterValues];
                          if (!_ps[i]) _ps[i] = {};

                          _ps[i].shouldRunScenarios = v;
                          this.setState({ parameterValues: _ps });
                        }
                      )}
                      <Text
                        style={{
                          marginStart: 5,
                          marginVertical: 10,
                          fontSize: 11,
                          color: Theme.COLORS.MUTED,
                        }}
                      >
                        {translate("area.notifyOnBreach")}
                      </Text>
                      {/* sirens */}
                      {this.renderToggle(
                        undefined,
                        translate("area.shouldTurnOnSirens"),
                        this.state.parameterValues[i].shouldTurnOnSirens ||
                          false,
                        (v) => {
                          var _ps = [...this.state.parameterValues];
                          if (!_ps[i]) _ps[i] = {};

                          _ps[i].shouldTurnOnSirens = v;
                          this.setState({ parameterValues: _ps });
                        }
                      )}
                      {/* notification */}
                      {this.renderToggle(
                        undefined,
                        translate("area.shouldNotifyBreach"),
                        this.state.parameterValues[i].shouldNotifyBreach ||
                          false,
                        (v) => {
                          var _ps = [...this.state.parameterValues];
                          if (!_ps[i]) _ps[i] = {};

                          _ps[i].shouldNotifyBreach = v;
                          this.setState({ parameterValues: _ps });
                        }
                      )}
                      {/* sms */}
                      {this.renderToggle(
                        undefined,
                        translate("area.shouldSmsBreach"),
                        this.state.parameterValues[i].shouldSmsBreach || false,
                        (v) => {
                          var _ps = [...this.state.parameterValues];
                          if (!_ps[i]) _ps[i] = {};

                          _ps[i].shouldSmsBreach = v;
                          this.setState({ parameterValues: _ps });
                        }
                      )}
                    </View>
                  );
                } else if (pt == "disarmmodel") {
                  return (
                    <View key={i}>
                      {/* doorlocks */}
                      {this.renderToggle(
                        undefined,
                        translate("area.shouldUnlockAfterDisArm"),
                        this.state.parameterValues[i].shouldUnlockAfterDisArm ||
                          false,
                        (v) => {
                          var _ps = [...this.state.parameterValues];
                          if (!_ps[i]) _ps[i] = {};

                          _ps[i].shouldUnlockAfterDisArm = v;
                          this.setState({ parameterValues: _ps });
                        }
                      )}
                    </View>
                  );
                } else
                  return (
                    <Text key={i}>
                      text input for {pt}, {pn}
                    </Text>
                  );
              })}
          </ScrollView>
        </ConditionEventLayout>
        <ArButton
          onPress={this.handleOnConfirm}
          style={{ marginTop: 20, width: "100%", alignSelf: "center" }}
        >
          {translate("app.next")}
        </ArButton>
      </View>
    );
  }
}
const styles = StyleSheet.create({
  tabContent: {
    marginBottom: 15,
    padding: 5,
  },
});

function mapStateToProps(state) {
  return {
    areaReducer: state.AreaReducer,
    deviceReducer: state.DeviceReducer,
  };
}

export default connect(mapStateToProps)(ActionGenerator);
